export default class View {

    static field(id, labelArgs = {}, inputArgs, fieldAttrs = {}) {

        inputArgs.id = id;

        // Create label element only if there's text content
        let label = null;

        if (labelArgs?.text || labelArgs?.altText) {
            if (!labelArgs.attrs) labelArgs.attrs = {};
            labelArgs.attrs.for = id;
            labelArgs.attrs.class = 'label';
            label = View.label(labelArgs);
        }

        // Determine the type of form element to create
        let element;
        switch (inputArgs.type) {
            case 'select':
                element = View.select(inputArgs);
                break;
            case 'textarea':
                element = View.textarea(inputArgs);
                break;
            default:
                element = View.input(inputArgs);
                break;
        }

        fieldAttrs.class = fieldAttrs.class ? 'form-control ' + fieldAttrs.class : 'form-control';

        // Create container and append elements
        const container = $('<div></div>').attr(fieldAttrs);

        if (label) container.append(label);
        if (element) container.append(element);

        return container;
    }

    static label({text = '', altText = '', attrs = {class: 'label'}} = {}) {

        const label = $('<label>').attr(attrs);

        if (text) {
            label.append($('<span>').addClass('label-text').text(text));
        }

        if (altText) {
            label.append($('<span>').addClass('label-text-alt').text(altText));
        }

        return label;
    }

    static select(args = {}) {
        const defaults = {
            value: '',
            options: [],
            placeholder: ''
        };

        // Merge defaults with args
        args = {...defaults, ...args};

        // Normalize the value to an array for consistency
        const selectedValues = Array.isArray(args.value) ? args.value : [args.value];

        // Normalize options: convert simple arrays to object format
        const normalizedOptions = args.options.map(option => {
            if (typeof option === 'object' && option !== null) {
                // Already in {value, label} format
                return {
                    value: option.value?.toString() || '',
                    label: option.label?.toString() || option.value?.toString() || ''
                };
            } else {
                // Simple value (string/number) - use it as both value and label
                return {
                    value: option?.toString() || '',
                    label: option?.toString() || ''
                };
            }
        });

        // Generate HTML attributes, excluding options and placeholder
        const attrs = Object.entries(args)
            .filter(([key]) => key !== 'options' && key !== 'placeholder')
            .map(([key, val]) => `${key}="${val}"`)
            .join(' ');

        // Generate options HTML
        const optionsHTML = normalizedOptions.map((item) => {
            const selected = selectedValues.includes(item.value.toString()) ? 'selected' : '';
            return `<option value="${item.value}" ${selected}>${item.label}</option>`;
        }).join('');

        // Create the select HTML with optional placeholder
        return $(`
        <select ${attrs}>
            ${args.placeholder ? `<option value="">${args.placeholder}</option>` : ''}
            ${optionsHTML}
        </select>
    `);
    }


    static input(args = {}) {

        const defaults = {
            type: 'text',
            value: '',
            placeholder: '',
            class: 'input input-bordered'
        };

        // Merge defaults with args using spread syntax
        args = {...defaults, ...args};

        // Generate HTML attributes from the attrs object
        const attrs = Object.entries(args)
            .map(([key, val]) => `${key}="${val}"`)
            .join(' ');

        return $(`<input ${attrs}>`);
    }

    static textarea(args = {}) {
        const defaults = {
            value: '',
            placeholder: '',
            rows: 4,
            cols: 50
        };

        // Merge defaults with args using spread syntax
        args = {...defaults, ...args};

        // Extract value separately since it goes between the tags, not as an attribute
        const value = args.value;
        delete args.value; // Remove value from args so it's not added as an attribute

        // Generate HTML attributes from the attrs object
        const attrs = Object.entries(args)
            .map(([key, val]) => `${key}="${val}"`)
            .join(' ');

        return $(`<textarea ${attrs}>${value}</textarea>`);
    }

    static selectWorkers(value) {
        return this.select({
            value: value,
            name: 'workers',
            multiple: 1,
            options: ESR.workers
        })
    }

    static datepicker($input, options = {}) {
        if ($input) {
            $input.datepicker({
                language: 'ro',  // Romanian language for datepicker, or use other options
                todayHighlight: true,
                todayBtn: true,
                autoclose: true, // Closes datepicker on date selection
                ...options       // Spread any additional options
            });
        }
    }



    // Helper to create form controls with labels and inputs
    //todo refactor Used in popupCreateUpdateProject()
    static createFormControl(labelText, inputElement) {
        return $(`
            <label class="form-control w-full">
                <div class="label">
                    <span class="label-text">${labelText}</span>
                </div>
            </label>
        `).append(inputElement);
    }

}

